import { COMPANY, NAV_LINKS } from "../constants/site";

export default function Footer({ onNav }) {
  return (
    <footer data-testid="main-footer" className="relative border-t border-line bg-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 pt-16 pb-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <div>
            <h2 data-testid="footer-brand-wordmark" className="font-display text-[16vw] lg:text-[9rem] leading-[0.85] font-extrabold tracking-tight text-gradient select-none">
              TACCTAX
            </h2>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.3em] text-slate-400">
              {COMPANY.tagline}
            </p>
          </div>
          <div className="flex flex-col gap-3 lg:items-end">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => onNav(l.href)}
                className="text-left lg:text-right text-sm font-semibold text-slate-500 hover:text-torange transition-colors cursor-pointer"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row justify-between gap-4 border-t border-line pt-8">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-slate-400 max-w-xl">
            Offshore preparation workflows operate with client consent and
            confidentiality protocols aligned to IRS §7216 requirements.
          </p>
        </div>
      </div>
    </footer>
  );
}
